import Vue from 'vue'
import Router from 'vue-router'
import Lander from '@/flows/Lander/Lander'
import Login from '@/flows/Login/Login'
import Register from '@/flows/Register/Register'
import Company from '@/flows/Company/Company'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'Lander',
			component: Lander
		},
		{
			path: '/login',
			name: 'Login',
			component: Login
		},,
		{
			path: '/register',
			name: 'Register',
			component: Register
		},
		{
			path: '/company/:company',
			name: 'Company',
			component: Company
		},
	],
	mode: 'history'
})


// WEBPACK FOOTER //
// ./src/router/index.js